module.exports = __webpack_public_path__ + "img/mt.1685efea.jpg";